import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ahaApi from "../../../app/services/aha-api";
const initialState = {
  value: [],
  loading: false,
};

export const fetchCareDxDropSite = createAsyncThunk(
  "careDxDropSite/fetch",
  async (data, { rejectWithValue }) => {
    const response = await ahaApi.Account.fetchDropSite(data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return rejectWithValue(err.response.data);
      });

    return response;
  }
);

export const fetchCareDxDropSiteSlice = createSlice({
  name: "careDxDropSite",
  initialState,
  reducers: {
    setFetchedCareDxDropSiteResponse(state, action) {
      state.value = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCareDxDropSite.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCareDxDropSite.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(fetchCareDxDropSite.rejected, (state, err) => {
        state.loading = false;
        state.value = err.payload;
      });
  },
});

export const fetchCareDxDropSiteResponse = (state) => state.fetchCareDxDropSite.value;
export const fetchCareDxDropSiteLoader = (state) => state.fetchCareDxDropSite.loading;
export const { setFetchedCareDxDropSiteResponse } = fetchCareDxDropSiteSlice.actions;

export default fetchCareDxDropSiteSlice.reducer;
